// extracted by mini-css-extract-plugin
export default {"wrapper":"CopyFilters_wrapper__Omfsa"};